import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import {
  cmes,
  formatoMonto,
  MESES,
  seleccionarCampo,
  validaMonto,
} from "../../util/varios";

export const ModalCrearDeuda1x1000 = (props) => {
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbAnio = useRef();
  const cmbDesde = useRef();
  const txtMonto = useRef();

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const Agregar = () => {
    const deu = {
      anio: parseInt(cmbAnio.current.value),
      mes: cmes(parseInt(cmbDesde.current.value)),
      monto: parseFloat(
        txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      intereses: 0.0,
      recargo: 0.0,
      multa: 0.0,
      retenciones: 0.0,
      credito: 0.0,
      totalperi: parseFloat(
        txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      status: 0,
      idfac: "",
      nummes: parseInt(cmbDesde.current.value),
      estatusfac: "",
      tipotransaccion: "",
      concepto: `IMPUESTO 1X1000 PERIODO: ${cmes(
        parseInt(cmbDesde.current.value)
      )}-${cmbAnio.current.value}`,
      tipodeuda: 3,
      tipodecla: 1,
      total: parseFloat(
        txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
    };

    props.onHide(deu);
  };

  const cancelar = () => {
    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Crear Deuda 1X1000</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="row border-azul rounded mx-auto col-sm-12 justify-content-between">
          <legend className="float-none m-0 w-auto">Periodo:</legend>
          <div className="row col-md-12 justify-content-between">
            <div style={{ width: 200 }} className="input-group mb-3">
              <label className="input-group-text" htmlFor="comboano">
                Año:
              </label>
              <select
                ref={cmbAnio}
                defaultValue={anioActu}
                className="form-select"
                id="comboano"
              >
                <option key={1} value={anioActu}>
                  {anioActu}
                </option>
                <option key={2} value={anioActu - 1}>
                  {anioActu - 1}
                </option>
                <option key={3} value={anioActu - 2}>
                  {anioActu - 2}
                </option>
                <option key={4} value={anioActu - 3}>
                  {anioActu - 3}
                </option>
                <option key={5} value={anioActu - 4}>
                  {anioActu - 4}
                </option>
              </select>
            </div>
            <div style={{ width: 250 }} className="input-group mb-3">
              <label className="input-group-text" htmlFor="mesdesde">
                Mes:
              </label>
              <select ref={cmbDesde} className="form-select" id="mesdesde">
                {MESES.map((item, i) => (
                  <option key={i} value={item.number}>
                    {item.text.toUpperCase()}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ width: 250 }} className="input-group mb-3">
              <label className="input-group-text" id="monto">
                Monto:
              </label>
              <input
                type="text"
                style={{ minHeight: "100%" }}
                defaultValue={"0,00"}
                ref={txtMonto}
                onFocus={seleccionarCampo}
                onBlur={handleInputMontoChange}
                onKeyUp={handleInputMontoChange}
                className="form-control text-end"
                aria-label="campo monto"
                aria-describedby="monto"
              />
            </div>
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={Agregar}
          style={{ margin: "1px" }}
          className="fw-bold btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i> Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="fw-bold btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i> Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/modalCrearDeuda1x1000.js